import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_integrations_index',
          meta: {
            permissions: [
              'administrator',
              'account_manage',
              'integration_manage',
            ],
          },
          component: () => import('./Index.vue'),
        },
      ],
    },
  ],
};
